/** i18n namespace shared by every part of the assistant. */
export const AI_ORCHESTRATOR_NAMESPACE = 'dashboard/ai-orchestrator';
